import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { STATES } from "@/data/states";

function StateLink({ name, slug }: { name: string; slug: string }) {
  return (
    <Link
      to={`/browse/${slug}`}
      className="group text-sm text-muted-foreground hover:text-primary transition-colors py-1.5 flex items-center gap-1.5"
    >
      <ArrowRight className="w-3 h-3 shrink-0 text-teal-400/60 group-hover:translate-x-0.5 transition-transform" />
      MedSpas in {name}
    </Link>
  );
}

function StatesGrid() {
  // Split 50 states into 5 columns of 10
  const columns: (typeof STATES)[] = [];
  for (let i = 0; i < 5; i++) {
    columns.push(STATES.slice(i * 10, i * 10 + 10));
  }

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-0">
        {columns.map((col, i) => (
          <div key={i}>
            {col.map((state) => (
              <StateLink key={state.slug} name={state.name} slug={state.slug} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function InternalLinks() {
  return (
    <section className="py-16 lg:py-24 border-t border-white/10">
      <div className="container mx-auto px-4 lg:px-8">
        <SectionHeading
          eyebrow="Browse by State"
          title={
            <>
              Find MedSpas <span className="text-gradient-aqua">Near You</span>
            </>
          }
          description="Explore verified medical spas in all 50 states"
        />
        <div className="card-premium p-6 lg:p-8">
          <StatesGrid />
        </div>
      </div>
    </section>
  );
}
